module.exports = __webpack_public_path__ + "/static/assets/fe5afd6776eac0f7724b132a9ff5057d.svg";